import BasicInterstitial from './BasicInterstitial';
import { jsx as _jsx } from "react/jsx-runtime";
const LessonCompleteInterstitial = () => /*#__PURE__*/_jsx(BasicInterstitial, {
  buttonI18n: "learningCenter.heading.backToLessons.link",
  buttonLink: "/lessons",
  headingI18n: "learningCenter.lessonInterstitials.lessonComplete",
  illustrationName: "success-green",
  subheadingI18n: "learningCenter.lessonInterstitials.keepUpTheGoodWork",
  use: "success"
});
export default LessonCompleteInterstitial;